import Service from "../pages/service/add";
import CatalogTable from "../pages/catalog/catalogTable";

const routesCatalog = [
  {
    path: "/catalog",
    element: <CatalogTable />,
  },
];

export default routesCatalog;
